export const SERVICES_IN_SERP_FEATURE_FLAG = 'services_in_serp';
export const SWISH_GC_CHECKOUT_FEATURE_FLAG = 'swish_gc_checkout';
export const QLIRO_GC_CHECKOUT_FEATURE_FLAG = 'qliro_gc_checkout';
export const DEALS_FEATURE_FLAG = 'deals_smoke_test';
export const NEW_PLACE_TWEAKS_EXPERIMENT = 'new-place-page-tweaks';
export const MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY = 'megamenu_navigation_place_only';
export const CHECKOUT_REDESIGN_FEATURE_FLAG = 'checkout_redesign';
export const FINNISH_TRANSLATION_FEATURE_FLAG = 'finnish-translation';
export const LOCATIONS_SEARCH_EXPERIMENT = 'locations-search';
export const NEAR_ME_FLAG = 'near-me-autoscaling';
export const LOCATION_IDS_FILTER = 'locationids-filter';

// add here all the search flags that should be sent to the backend
export const SEARCH_FLAGS = [NEAR_ME_FLAG, LOCATION_IDS_FILTER, LOCATIONS_SEARCH_EXPERIMENT];
